<div class="flex items-center" mat-dialog-title>
  <h2 class="headline m-0 flex-auto">
    {{ "Add Quotation" }}
  </h2>

  <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
    <mat-icon svgIcon="mat:close"></mat-icon>
  </button>
</div>

<mat-divider class="text-border"></mat-divider>

<mat-dialog-content>
  <form [formGroup]="form" class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <vex-common-autocomplete
      [valueList]="companyList"
      [label]="'Company'"
      (optionSelected)="onCompanySelection($event)">
    </vex-common-autocomplete>
    <mat-form-field>
      <mat-label>Payment Method</mat-label>
      <mat-select
        formControlName="paymentMethod"
        placeholder="Select payment method">
        <mat-option
          *ngFor="let option of paymentMethodLIst"
          [value]="option.id"
          >{{ option.value }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <!-- <mat-form-field>
      <mat-label>Price</mat-label>
      <input formControlName="Price" matInput />
    </mat-form-field> -->
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close type="button">Cancel</button>
  <button color="primary" mat-flat-button type="submit" (click)="onSubmit()">
    <ng-container *ngIf="!isEdit">Create Quotation</ng-container>
  </button>
</mat-dialog-actions>
